export default __webpack_public_path__ + "static/media/small-calendar.a28a78f6.svg";